<div class="cardform">
  <mat-card>
    <mat-card-content>
      <div class="step-content">
        <div class="success-message" *ngIf="success">
          <mat-icon color="primary">check_circle</mat-icon>
          <h2>Staff criado com sucesso!</h2>
          <p>{{ message || 'O voluntário foi registrado com sucesso no evento.' }}</p>
          <div class="actions">
            <button mat-raised-button color="primary" (click)="finish.emit(1)">
              Voltar para o Início
            </button>
            <button mat-raised-button color="accent" style="margin: 10px;" (click)="finish.emit(2)">
              Adicionar outro Staff neste Evento
            </button>
          </div>
        </div>
        <div class="error-message" *ngIf="!success">
          <mat-icon color="warn">error</mat-icon>
          <h2>Erro ao criar staff</h2>
          <p>{{ message || 'Houve um problema ao registrar o voluntário. Por favor, tente novamente.' }}</p>
          <div class="actions">
            <button mat-raised-button color="warn" (click)="finish.emit(1)">
              Voltar para o Início
            </button>
            <button mat-raised-button color="accent" (click)="finish.emit(2)">
              Adicionar outro Staff neste Evento
            </button>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
